"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDifferenceInSeconds = exports.getDatesDifference = exports.sortDates = exports.formattedDate = exports.dateToTimeString = exports.dateToString = exports.dateIsValid = void 0;
const helpers_1 = require("../../helpers");
const Sort_1 = require("../Sort");
const dateIsValid = (date) => {
    return !Number.isNaN(new Date(date).getTime());
};
exports.dateIsValid = dateIsValid;
const dateToString = (date, separator) => {
    if (date && (0, exports.dateIsValid)(date)) {
        const str = date.toISOString().substring(0, 10);
        if (separator)
            return str.replace(/-/g, separator);
        return str;
    }
    return undefined;
};
exports.dateToString = dateToString;
const dateToTimeString = (date) => {
    if (date && (0, exports.dateIsValid)(date))
        return date.toISOString().substring(0, 10) + " " + (0, helpers_1.formatTime)(date);
    return undefined;
};
exports.dateToTimeString = dateToTimeString;
const formattedDate = (date) => {
    if (date)
        return date.toLocaleDateString("cs-CZ");
    else
        return "nezadáno";
};
exports.formattedDate = formattedDate;
const sortDates = (a, b, increasingOrder = true) => {
    return (0, Sort_1.definedFirstSort)(a, b, (a, b) => {
        const diff = a.getTime() - b.getTime();
        return increasingOrder ? diff : -diff;
    });
};
exports.sortDates = sortDates;
const getDatesDifference = (dateFirst, dateSecond) => {
    return dateSecond.getTime() - dateFirst.getTime();
};
exports.getDatesDifference = getDatesDifference;
const getDifferenceInSeconds = (dateFirst, dateSecond) => {
    return (0, exports.getDatesDifference)(dateFirst, dateSecond) / 1000;
};
exports.getDifferenceInSeconds = getDifferenceInSeconds;
